import React, { useEffect } from 'react';
import Modal from '../Modal';

import styles from './notification.module.scss';
import { useHistory } from 'react-router-dom';
import Button from '../button/button';

const Complete = ({
  setTheme,
  txHash,
  redirectURL,
  txLogs,
  transactionInfo,
}: {
  setTheme: any;
  txHash: string | undefined;
  redirectURL: string | undefined;
  txLogs:any;
  transactionInfo?:any
}) => {
  const history = useHistory();
  function onClose() {
    setTheme({
      type: undefined,
      subType: undefined,
    });
    if (redirectURL) {
      history.push(redirectURL);
      redirectURL === "/" && window.location.reload();
    } else {
      window.location.reload();
    }
  }

  return (
    <>
    <Modal isOpen={true} title='' onClose={() => onClose()} zIndex={4} center>
      <div className={styles.notification_content}>
        {/* <img src={CompleteIcon} alt='wait' /> */}
        <p className={styles.title}>Your Digital Pass has been created!</p>
        {/* <div className={styles.description}>
          View My Digital Pass
        </div> */}
        {/* <div className={styles.transactionId}>
          Transaction ID:
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`https://www.mintscan.io/juno/txs/${txHash}`}
          >
            {txHash}
          </a>
        </div> */}
        <div>
          <Button className='btn_full btn_centered btn_solid' onClick={() => onClose()}>
            Click here to visit your profile now
          </Button>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default Complete;
